import type { ReactElement } from "react";
import { Link, useParams } from "react-router";

import { useApiData } from "../../api/use-api-data.js";
import { usePageMeta } from "../../app/use-page-meta.js";
import { ApiState, titleFor } from "../../components/api-state.js";
import { EstimateSheet } from "../estimates/estimate-sheet.js";

import type { CenterEstimate } from "./estimate-types.js";
import { adminCenterApi, adminCenterUrls } from "./urls.js";

/**
 * 見積書 1 通（管理センター。社内へ知らせるメールのリンクの先）。<b>紙面は見積書の作成後と同じ部品</b>（<c>estimates/estimate-sheet.tsx</c>）で、
 * 印刷できる。作成日時と作った人は紙に出さない区画に出す。
 * 開けるかはサーバが決める（請求の権限。無ければ・無い番号なら 404 →「見つからない」）。
 */
export function CenterEstimatePage(): ReactElement | null {
    const { id = "" } = useParams();
    const data = useApiData<CenterEstimate>(adminCenterApi.estimate(id));
    usePageMeta(titleFor(data, data.state === "ready" ? `見積書 ${data.value.estimate.estimateNumber}` : "見積書"));

    if (data.state !== "ready") {
        return <ApiState data={data} what="見積書" />;
    }
    const found = data.value;

    return (
        <div className="page max-w-3xl">
            <div className="mb-4 flex items-center justify-between print:hidden">
                <Link to={adminCenterUrls.estimates()} className="btn-secondary btn-sm">見積の検索へ戻る</Link>
                <button type="button" className="btn-secondary btn-sm" onClick={() => { globalThis.print(); }}>
                    印刷する
                </button>
            </div>

            <section className="card mb-4 p-6 print:hidden" data-estimate-record="">
                <h2 className="section-title">作成の記録</h2>
                <dl className="grid gap-3 sm:grid-cols-2">
                    <div><dt className="text-xs text-slate-500">作成日時</dt><dd>{found.createdLabel}</dd></div>
                    <div>
                        <dt className="text-xs text-slate-500">作った人</dt>
                        <dd>{found.createdByLabel ?? <span className="badge-muted">ログインせずに作成</span>}</dd>
                    </div>
                </dl>
            </section>

            <EstimateSheet estimate={found.estimate} />
        </div>
    );
}
